import { Routes, Route, Navigate } from 'react-router-dom'

import Login from 'pages/login'
import Announcement from 'pages/announcement'
import FutureProgram from 'pages/todaysprogram/futureprogram'
import ArchiveList from 'pages/todaysprogram/archivelist'
import Team from 'pages/team'
import User from 'pages/user'
import LibraryCategory from 'pages/library/librarycategory'
import LibraryBook from 'pages/library/librarybook'
import BusinessCategory from 'pages/business/businesscategory'
import DayAdjustment from 'pages/dayadjustment'
import Feedback from 'pages/feedback'
import FeedbackType from 'pages/feedbacktype'
import GeneralSettings from 'pages/generalsettings'
import CalendarSetting from 'pages/calendarsetting/specialDay'
import BusinessList from 'pages/business/businesslist'
import Donation from 'pages/Donation/donation'
import Sadaqah from 'pages/Donation/Sadaqah'
import DonationType from 'pages/donationtype'
import CreateSubAdmin from 'pages/CreateSubAdmin'
import Fitra from 'pages/Donation/fitra'
import HijriCalendar from 'pages/calendarsetting/hijridates'
import Dashboard from 'pages/dashboard'
import Banner from 'pages/banner'
import MembershipPricing from 'pages/membership/pricing'
import MembershipPurchaseList from 'pages/membership/purchaselist'
import ProtectedRoute from 'router/ProtectedRouter'
import { PERMISSIONS } from 'constants/RoutePermission.constant'

const Navigation = () => {
  return (
    <Routes>
      <Route exact path="/login" element={<Login />} />
      <Route
        path="/createsubadmin"
        element={
          <ProtectedRoute permissions={PERMISSIONS.CREATE_ADMIN}>
            <CreateSubAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute permissions={PERMISSIONS.DASHBOARD}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/announcement"
        element={
          <ProtectedRoute permissions={PERMISSIONS.ANNOUNCEMENT}>
            <Announcement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/library/category"
        element={
          <ProtectedRoute permissions={PERMISSIONS.LIBRARY}>
            <LibraryCategory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/library/book"
        element={
          <ProtectedRoute permissions={PERMISSIONS.LIBRARY}>
            <LibraryBook />
          </ProtectedRoute>
        }
      />
      <Route
        path="/program/today"
        element={
          <ProtectedRoute permissions={PERMISSIONS.PROGRAM}>
            <FutureProgram />
          </ProtectedRoute>
        }
      />
      <Route
        path="/archive/list"
        element={
          <ProtectedRoute permissions={PERMISSIONS.PROGRAM}>
            <ArchiveList />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/daysadjustment"
        element={
          <ProtectedRoute permissions={PERMISSIONS.DAYS_ADJUSTMENT}>
            <DayAdjustment />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/calendersetting/specialdays"
        element={
          <ProtectedRoute permissions={PERMISSIONS.CALENDER_SETTING}>
            <CalendarSetting />
          </ProtectedRoute>
        }
      />
      <Route
        path="/team"
        element={
          <ProtectedRoute permissions={PERMISSIONS.TEAM}>
            <Team />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/category"
        element={
          <ProtectedRoute permissions={PERMISSIONS.BUSINESS}>
            <BusinessCategory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business/list"
        element={
          <ProtectedRoute permissions={PERMISSIONS.BUSINESS}>
            <BusinessList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user"
        element={
          <ProtectedRoute permissions={PERMISSIONS.USER}>
            <User />
          </ProtectedRoute>
        }
      />
      <Route
        path="/feedback/list"
        element={
          <ProtectedRoute permissions={PERMISSIONS.FEEDBACK}>
            <Feedback />
          </ProtectedRoute>
        }
      />
      <Route
        path="/feedback/type"
        element={
          <ProtectedRoute permissions={PERMISSIONS.FEEDBACK}>
            <FeedbackType />
          </ProtectedRoute>
        }
      />
      <Route
        path="/donation/donation"
        element={
          <ProtectedRoute permissions={PERMISSIONS.DONATION}>
            <Donation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/donation/sadaqah"
        element={
          <ProtectedRoute permissions={PERMISSIONS.DONATION}>
            <Sadaqah />
          </ProtectedRoute>
        }
      />
      <Route
        path="/donation/fitra"
        element={
          <ProtectedRoute permissions={PERMISSIONS.DONATION}>
            <Fitra />
          </ProtectedRoute>
        }
      />
      <Route
        path="/donationtype"
        element={
          <ProtectedRoute permissions={PERMISSIONS.DONATION_TYPE}>
            <DonationType />
          </ProtectedRoute>
        }
      />
      <Route
        path="/generalsetting"
        element={
          <ProtectedRoute permissions={PERMISSIONS.GENERAL_SETTING}>
            <GeneralSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/banner"
        element={
          <ProtectedRoute permissions={PERMISSIONS.BANNER}>
            <Banner />
          </ProtectedRoute>
        }
      />
      <Route
        path="/calendersetting/hijricalender"
        element={
          <ProtectedRoute permissions={PERMISSIONS.CALENDER_SETTING}>
            <HijriCalendar />
          </ProtectedRoute>
        }
      />
      <Route
        path="/membership/pricing"
        element={
          <ProtectedRoute permissions={PERMISSIONS.MEMBERSHIP}>
            <MembershipPricing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/membership/purchaselist"
        element={
          <ProtectedRoute permissions={PERMISSIONS.MEMBERSHIP}>
            <MembershipPurchaseList />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  )
}

export default Navigation
